"use client"

import clsx from "clsx"
import React from "react"

import { AllEventSlidesProps } from "@/types/events"

import Card from "../cards/Card"

const AllEventSlides: React.FC<AllEventSlidesProps> = ({
  data,
  className,
  ...divProps
}) => (
  <>
    {data.map((events, index) => (
      <div
        key={events?.link}
        className="embla__slide flex-[0_0_100%] md:flex-[0_0_57%] lg:flex-[0_0_40%] min-w-0 md:pr-8"
        {...divProps}
      >
        <div className={className}>
          <Card
            index={index}
            uri={events?.link}
            mainImage={events?.thumbnailImage?.url}
            title={events?.title}
            cardType={events?.friendlyDate}
            linkClassName={clsx(className)}
            location={events?.location}
          />
        </div>
      </div>
    ))}
  </>
)

export default AllEventSlides
